import React, { useEffect, useState } from "react";

const CHECK_SESSION_URL = "https://www.interviewaxis.com/api/v1/check-session";
const LOGIN_URL = "https://www.interviewaxis.com/login";

const ProtectedRoute = ({ element }) => {
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    fetch(CHECK_SESSION_URL, { credentials: "include" })
      .then((r) => r.json())
      .then((data) => {
        if (data.logged_in === true) {
          setStatus("ok");
        } else {
          window.location.href = LOGIN_URL;
        }
      })
      .catch(() => {
        window.location.href = LOGIN_URL;
      });
  }, []);

  if (status === "loading") {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0f172a",
          color: "#94a3b8",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          fontSize: "1rem",
          gap: "12px",
        }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          style={{ animation: "spin 0.8s linear infinite" }}
        >
          <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
          <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
        </svg>
        Verifying session…
      </div>
    );
  }

  return element;
};

export default ProtectedRoute;
